import { render, staticRenderFns } from "./TOC.vue?vue&type=template&id=58ee6250&scoped=true&"
import script from "./TOC.vue?vue&type=script&lang=js&"
export * from "./TOC.vue?vue&type=script&lang=js&"
import style0 from "./TOC.vue?vue&type=style&index=0&id=58ee6250&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee6250",
  null
  
)

export default component.exports